export enum CoverMyMedsLogType {
  ApiRequest = 'ApiRequest',
  Callback = 'Callback',
  FaxMissing = 'FaxMissing',
}
